<template>
  <div class="referrer_box">
    <el-row>
      <el-col :span="12">
        <span class="page-title">My Shares</span>
      </el-col>
      <el-col :span="12" class="back-col">
        <span @click="goBack()" class="btn-back"><i class="el-icon-arrow-left"></i>BACK</span>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-table
          :data="tableData"
          style="width: 100%;">
          <el-table-column
            prop="name"
            min-width="150"
            label="Name">
          </el-table-column>
          <el-table-column
            prop="email"
            min-width="200"
            label="Email">
          </el-table-column>
          <el-table-column
            prop="address"
            min-width="250"
            label="Property Address">
          </el-table-column>
          <el-table-column
            prop="createTimeFormat"
            min-width="150"
            label="Shared Time">
          </el-table-column>
          <el-table-column
            prop="referrerName"
            min-width="150"
            label="Shared By">
          </el-table-column>
          <el-table-column
            prop="address"
            min-width="250"
            label="Actions">
            <template slot-scope="scope">
              <el-button class="btn-link" @click="showDetail(1,scope.row)" type="text" icon="el-icon-view">View
                Property
              </el-button>
              <span class="divider"> | </span>
              <el-button class="btn-link" @click="handleDelete(scope.row)" type="text" icon="el-icon-delete">Remove
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="fen" v-if="total">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="25"
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </el-col>
    </el-row>

    <!-- Delete pop-up box -->
    <el-dialog
      title="Are you sure you want to remove shared property?"
      :visible.sync="delDio"
      :append-to-body="true"
      class="accountdio"
      :show-close="false"
      center
      width="470px">
      <div slot="footer" class="dialog-footer">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-button type="info" @click="delDio = false"
                       style="background:#dedede; color:#333333;border:none;width:100%;">Cancel
            </el-button>
          </el-col>
          <el-col :span="12">
            <el-button type="primary" @click="delsharedproperty" style="background:#003333;border:none;width:100%;">
              Delete
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'myConnects',
  data() {
    return {
      time: [],
      index: '',
      isNew: false,
      proList: [1, 2, 3, 4, 5, 6],
      wordP: '',
      propertyDio: false,
      keyword: '',
      tableData: [],
      page: 1,
      page1: 1,
      size: 25,
      total: 0,
      total1: 0,
      delDio: false,
      msg: '',
    }
  },
  methods: {
    ...mapActions(['getHouseSharePasswordLists', 'deleteSharedProperty', 'getHouseLists']),
    handleSizeChange(val) {
      this.size = val
      this.gethousesharepasswordlist()
    },
    handleCurrentChange(val) {
      this.page = val
      this.gethousesharepasswordlist()
    },
    gethousesharepasswordlist() {
      let pat = {
        page: this.page,
        size: this.size,
        search: this.keyword,
        startTime: 0,
        endTime: 9999999999,
      }
      if (this.time != null && this.time.length) {
        pat.startTime = this.time ? this.time[0].getTime() / 1000 : '',
          pat.endTime = this.time ? (this.time[1].getTime() + 86400000) / 1000 - 1 : ''
      }
      this.getHouseSharePasswordLists({pat: pat, callback: this.callback})
    },
    delsharedproperty() {
      this.deleteSharedProperty({pat: {id: this.msg.id}, callback: this.callback})
    },
    callback(resp, status) {
      switch (status) {
        case 'getHouseSharePasswordLists':
          if (resp.code == 0) {
            this.total = resp.data.totalRecord
            this.tableData = resp.data.list
          } else {
            Utils.alert('', resp.message, 'error')
          }
          break;
        case 'deleteSharedProperty':
          if (resp.code == 0) {
            this.delDio = false
            this.gethousesharepasswordlist()
          } else {
            Utils.alert('', resp.message, 'error')
          }
          break;
        case 'getHouseLists':
          if (resp.code == 0) {
            this.total1 = resp.data.totalRecord
            this.proList = resp.data.list
          } else {
            Utils.alert('', resp.message, 'error')
          }
          break;
        default:
          break;
      }
    },
    showDetail(key, val) {
      if (key == 1) {
        this.$router.push({path: '/uconnect/view', query: {pid: val.propertyId}})
      }
    },
    gethome() {
      let pat = {
        page: this.page1,
        size: 8,
        lineType: !this.isNew ? 'online' : 'offline',
        proertyType: 'all',
        search: this.wordP,
      }
      this.getHouseLists({pat: pat, callback: this.callback})
    },
    goBack() {
      this.$router.go(-1)
    },
    handleDelete(row) {
      this.delDio = true;
      this.msg = row;
    }
  },
  mounted() {
    this.gethousesharepasswordlist()
    this.gethome()
  },
  activated() {
    let query = this.$route.query
    if (query.from == 'a') {
      this.gethousesharepasswordlist()
    }
  },
  watch: {
    propertyDio(n, o) {
      if (!n) {
        this.index = -1
        this.wordP = ''
        this.page1 = 1
      }
    }
  },
}
</script>

<style lang='scss'>
.referrer_box {
  border-radius: 0 0 5px 5px;
  background-color: #ffffff;
  padding: 20px 10px 0 10px;
}

.btnList_box {
  margin-top: 40px;
}

.centerBtn {
  text-align: center;

  &:nth-child(1) {
    margin-bottom: 20px;
  }
}

.btn-back {
  color: #003333;
  font-weight: 600;
  font-size: 24px;
  line-height: 125%;
  cursor: pointer;
  text-decoration: underline;
}

.back-col {
  display: flex;
  justify-content: flex-end;
}

.page-title {
  color: #003333;
  font-weight: 600;
  font-size: 24px;
}

.btn-link {
  color: rgba(0, 51, 51, 0.9);
  font-family: 'DINosaur-a', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-decoration-line: underline;
}

.btn-link:hover {
  color: #003333;
}
</style>



// WEBPACK FOOTER //
// src/components/connects/myConnects.vue